/**!
 * I18N v1.0.1.20190128
 */
class I18N {
	constructor(locale = '_', i18nText = {}, componentName, customI18nText = {})
	{
		this.defaultLocale = '_';
		this.internationalization = i18nText;
		this.componentName = componentName;
		this.customInternationalization = customI18nText;
		this.cache = {};
		this.setLocale(locale);
	}

	setLocale(locale)
	{
		this.locale = locale;

		this.customLocalText = this.customInternationalization[this.locale] || {};
		this.appLocalTextComponent = (window.appLocaleText && !!this.componentName && window.appLocaleText[this.locale] && window.appLocaleText[this.locale][this.componentName]) || {};
		this.localization = this.internationalization[this.locale] || {};

		if (this.locale !== this.defaultLocale)
		{
			this.defaultCustomLocalText = this.customInternationalization[this.defaultLocale] || {};
			this.defaultAppLocalTextComponent = (window.appLocaleText && !!this.componentName && window.appLocaleText[this.defaultLocale] && window.appLocaleText[this.defaultLocale][this.componentName]) || {};
			this.defaultLocalization = this.internationalization[this.defaultLocale] || {};
		}
	}

	get(key, variable, isDefault)
	{
		let value = '',
				tempCustomLocalText = this.customLocalText,
				tempAppLocalTextComponent = this.appLocalTextComponent,
				tempLocalization = this.localization;
		if (!!isDefault && this.locale !== this.defaultLocale)
		{
			tempCustomLocalText = this.defaultCustomLocalText;
			tempAppLocalTextComponent = this.defaultAppLocalTextComponent;
			tempLocalization = this.defaultLocalization;
		}
		if (this.cache[key] !== undefined)
		{
			// 0. From cache
			value = this.cache[key];
		}
		else if (tempCustomLocalText[key] !== undefined)
		{
			// 1. From custom Internationalization
			value = tempCustomLocalText[key];
		}
		else if (tempAppLocalTextComponent[key] !== undefined)
		{
			// 2. From project window.appLocaleText
			value = tempAppLocalTextComponent[key];
		}
		else if (I18N.getLocalizeString(key) !== null)
		{
			// 3. From jsp display none key
			value = I18N.getLocalizeString(key);
		}
		else if (tempLocalization[key] !== undefined)
		{
			// 4. From component default internationalization
			value = tempLocalization[key];
		}
		else
		{
			if (this.locale !== this.defaultLocale && !isDefault)
			{
				value = this.get(key, variable, true);
			}
			if (value === '' || value === undefined)
			{
				// 5. End default with empty string and error log
				throw(new Error(`[I18N] - Key: "${key}" could not find! \nPlease check custom-option/window.appLocaleText/jsp-display-none/component-strings.`));
			}
		}

		if (!!variable && Object.keys(variable).length)
		{
			value = I18N.replaceStringVariable(value, variable);
		}

		this.cache[key] = value;

		return value;
	}

	// Utils
	static getLocalizeString(key)
	{
		let obj = document.getElementById("msg_" + key),
				result = null;
		if (obj != null)
		{
			result = obj.innerHTML.replace(/\\n/g, "\n");
		}
		return result;
	}

	static replaceStringVariable(str, variable)
	{
		let result = str;
		for (let varKey in variable)
		{
			if (variable.hasOwnProperty(varKey))
			{
				result = result.replace(new RegExp(`{{${varKey}}}`, 'g'), variable[varKey]);
			}
		}
		return result;
	}
}

export default I18N;